import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface ExecUnrejectSystemManagement {
  actionName: 'execUnrejectSystemManagement';
  request: mtechnavi.api.company.IUnrejectSystemManagementRequest;
}

export const execUnrejectSystemManagement = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IUnrejectSystemManagementRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/UnrejectSystemManagement';

  const result = await worker.invokeListRequest(execMethodName, {
    businessUnitManagementId: req.businessUnitManagementId,
  });
  return result;
};
